import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  withRouter,
} from 'react-router-dom';
import {
  Container,
  Input,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { showModal } from '../../actions';
import { showConfirmationModal } from '../../actions/App';

import {
  APIgetFTPAccounts,
  APIdeleteFTPAccount,
} from '../../api/Importers';

import AdminHeader from '../../components/Admin/Header';
import AdminFooter from '../../components/Admin/Footer';
import AdminFTPAccountsList from '../../components/Admin/FTPAccounts/List';

import { getVisibleItemsText } from '../../helpers';
import { addFlashMessage } from '../../helpers/FlashMessages';
import { getUserSetting } from '../../helpers/Settings';
import {
  handleComponentParams,
  handleURLParams,
} from '../../helpers/URLParams';

import ErrorBoundary from '../../components/ErrorBoundary';
import Loading from '../../components/Loading';
import EmptyFTPAccounts from '../EmptyContainers/FTPAccounts';

class AdminFTPAccounts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      accounts: [],
      accountsTotal: 0,
      search: '',
      page: 1,
      perPage: getUserSetting('admin_per_page') || 20,
      orderBy: 'created_at',
      order: 'desc',
      loading: true,
    };

    this.searchRef = React.createRef();

    this.handleChangeOrder = this.handleChangeOrder.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeSearch = this.handleChangeSearch.bind(this);
    this.handleClearSearch = this.handleClearSearch.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleDeleteAccount = this.handleDeleteAccount.bind(this);
    this.loadAccounts = this.loadAccounts.bind(this);
    this.openFTPAccountEditModal = this.openFTPAccountEditModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { orderBy, order, search } = this.state;

    handleComponentParams(
      false,
      ['page', 'search', 'orderBy', 'order'],
      prevProps,
      this.setState.bind(this),
      this.loadAccounts,
      { orderBy, order, search },
    );
  }

  componentDidMount() {
    const { history, location } = this.props;
    const { orderBy, order, search } = this.state;

    const queryParams = new URLSearchParams(location.search);

    if (location.hash === '#add') {
      this.openFTPAccountEditModal(null);
    }

    handleComponentParams(
      true,
      ['page', 'search', 'orderBy', 'order'],
      null,
      this.setState.bind(this),
      this.loadAccounts,
      { orderBy, order, search },
    );

    if (!queryParams.get('orderBy')) {
      handleURLParams({ orderBy }, history);
    }

    if (!queryParams.get('order')) {
      handleURLParams({ order }, history);
    }
  }

  loadAccounts(silent = false) {
    const {
      search,
      page,
      perPage,
      orderBy,
      order,
    } = this.state;

    if (!silent) {
      this.setState({ loading: true });
    }

    APIgetFTPAccounts({
      search,
      page,
      per_page: perPage,
      order_by: orderBy,
      order,
    }).then((response) => {
      const { data } = response;
      if (data) {
        this.setState({
          loading: false,
          accounts: data.data,
          accountsTotal: data.meta.total,
        });
      }
    });
  }

  handleChangeOrder(orderBy, order) {
    const { history } = this.props;

    handleURLParams({ orderBy, order, page: 1 }, history);
    this.setState({
      orderBy,
      order,
      page: 1,
    });
  }

  handleChangePage(page) {
    const { history } = this.props;

    handleURLParams({ page }, history);
    this.setState({ page });
  }

  handleChangeSearch(e) {
    const { value } = e.target;
    this.setState({ search: value });
  }

  handleClearSearch(e) {
    e.preventDefault();
    this.searchRef.value = '';

    const { history } = this.props;

    handleURLParams({ search: '', page: 1 }, history);
    this.setState({
      search: '',
      page: 1,
    });
  }

  handleKeyPress(e) {
    const { search } = this.state;
    const { history } = this.props;

    if (e.key === 'Enter') {
      e.preventDefault();
      handleURLParams({ search }, history);
      this.setState({ page: 1 }, () => {
        this.loadAccounts();
      });
    }
  }

  handleDeleteAccount(accountId) {
    const {
      intl,
      handleDeleteAccount,
    } = this.props;
    const { history } = this.props;
    handleDeleteAccount(accountId, () => {
      addFlashMessage({
        type: 'success',
        text: intl.formatMessage({ defaultMessage: 'The account has been deleted' }),
      });

      handleURLParams({ page: 1 }, history);
      this.setState({ page: 1 }, () => {
        this.loadAccounts();
      });
    });
  }

  openFTPAccountEditModal(accountId) {
    const {
      intl,
      openFTPAccountEditModal,
    } = this.props;
    const { history } = this.props;
    openFTPAccountEditModal(accountId, () => {
      addFlashMessage({
        type: 'success',
        text: accountId ? intl.formatMessage({ defaultMessage: 'Your changes have been saved' }) : intl.formatMessage({ defaultMessage: 'A new account has been created' }),
      });

      if (accountId) {
        this.loadAccounts();
      } else {
        handleURLParams({ page: 1 }, history);
        this.setState({ page: 1 }, () => {
          this.loadAccounts();
        });
      }
    });
  }

  render() {
    const {
      intl,
    } = this.props;
    const {
      search,
      page,
      perPage,
      accountsTotal,
      loading,
    } = this.state;

    return (
      <div className="main-content ftp-accounts-content">
        <Container fluid>
          <AdminHeader
            title={intl.formatMessage({ defaultMessage: 'FTP accounts' })}
            icon="fa-server"
            itemName="account"
            itemsTotal={accountsTotal}
            itemsVisible={getVisibleItemsText(page, perPage, accountsTotal)}
            newItemTitle={intl.formatMessage({ defaultMessage: 'FTP account' })}
            loading={loading}
            handleNewItem={() => { this.openFTPAccountEditModal(null); }}
          />
          {loading ? (
            <Loading />
          ) : (
            <div className="content-wrapper">
              {accountsTotal > 0 && (
                <div className="position-relative inline-search">
                  <Input
                    id="account-search"
                    name="account-search"
                    bsSize="sm"
                    innerRef={(ref) => { this.searchRef = ref; }}
                    placeholder={intl.formatMessage({ defaultMessage: 'Type something and press Enter to search' })}
                    disabled={loading}
                    onChange={this.handleChangeSearch}
                    onKeyPress={this.handleKeyPress}
                    value={search}
                  />
                  {search && (
                    <a
                      href="#clear"
                      className="search-clear"
                      onClick={this.handleClearSearch}
                    >
                      <i className="fas fa-times" />
                    </a>
                  )}
                </div>
              )}
              <ErrorBoundary>
                {accountsTotal > 0 ? (
                  <AdminFTPAccountsList
                    {...this.state}
                    loadAccounts={this.loadAccounts}
                    handleChangeOrder={this.handleChangeOrder}
                    handleDeleteAccount={this.handleDeleteAccount}
                    openFTPAccountEditModal={this.openFTPAccountEditModal}
                  />
                ) : (
                  <EmptyFTPAccounts link="#add" handleNewItem={this.openFTPAccountEditModal} />
                )}
              </ErrorBoundary>
              <ErrorBoundary>
                <AdminFooter
                  {...this.state}
                  itemsTotal={accountsTotal}
                  handleChangePage={this.handleChangePage}
                />
              </ErrorBoundary>
            </div>
          )}
        </Container>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  openFTPAccountEditModal: (account = null, callback) => {
    dispatch(showModal('FTPAccountEditModal', {
      className: 'modal-edit-ftp-account',
      account,
      notificationCallback: callback,
    }));
  },
  handleDeleteAccount: (accountId, callback) => {
    const { intl } = props;
    const modalParams = {
      title: intl.formatMessage({ defaultMessage: 'Are you sure?' }),
      text: intl.formatMessage({ defaultMessage: 'Are you sure you want to delete this FTP account?' }),
      onConfirm: () => (
        APIdeleteFTPAccount(accountId).then(() => {
          callback();
        })
      ),
    };
    dispatch(showConfirmationModal(modalParams));
  },
});

AdminFTPAccounts.propTypes = {
  intl: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  openFTPAccountEditModal: PropTypes.func.isRequired,
  handleDeleteAccount: PropTypes.func.isRequired,
};

export default withRouter(injectIntl(connect(null, mapDispatchToProps)(AdminFTPAccounts)));
